const outcomeCopy = {
    created: ['success', 'added'],
    restored: ['success', 'restored'],
    staged: ['success', 'moved to To invite'],
    already_on_event: ['info', 'already on this event'],
    noop: ['info', 'already on this event'],
    invalid: ['warning', 'could not be added'],
    // "Assign me unowned contacts" was refused for this contact (#893): it was NOT added, so it is
    // never on the event without the owner the user asked for. The server's message says why.
    owner_not_assigned: ['warning', 'not added — you could not be made its Contact Owner'],
};

const contactLabel = (contact) => {
    if (!contact) return '';
    const name = `${contact.first_name || ''} ${contact.last_name || ''}`.trim();
    return name || contact.email || contact.contact_id || '';
};

/** Turn the opt-in API outcomes into one user-readable result per requested contact. */
export function eventEnrollmentOutcomeMessages(outcomes = [], contacts = []) {
    const byId = new Map(contacts.map(contact => [contact.contact_id, contact]));
    return outcomes.map(row => {
        const [tone, text] = outcomeCopy[row.outcome] || ['info', row.outcome || 'no change'];
        const label = contactLabel(byId.get(row.contact_id)) || row.contact_id || 'Contact';
        const reason = row.outcome === 'owner_not_assigned' && row.message ? ` (${row.message})` : '';
        return { tone, message: `${label}: ${text}${reason}` };
    });
}

export function eventEnrollmentOutcomeText(outcome) {
    return (outcomeCopy[outcome] || ['info', outcome || 'no change'])[1];
}
